<template>
  <el-col>
    <el-card class="data">
      <div class="data-title" slot="header">
        <img class="report-img" src="@/assets/images/channels.svg" alt="" />
        <span>TOP CHANNELS</span>
        <router-link class="overview-action" to="/artist/my-channels"
          >OVERVIEW<i class="el-icon-arrow-right"></i
        ></router-link>
      </div>
      <div
        class="tableCommands"
        :class="window.width < '710' ? 'flex-end' : 'd-none'"
      >
        <p
          class="ml10"
          v-for="(item, index) in columns"
          :key="index"
          @click="handleCommand(item)"
          :class="{ active: columnShown === item.name }"
        >
          {{ item.name }}
        </p>
      </div>
      <el-table
        :data="channel"
        class="w100 dashboard-table"
        v-loading="loading_channel"
      >
        <el-table-column label="Title" prop="name"></el-table-column>
        <el-table-column
          label="Countries"
          prop="country_name"
          align="right"
          v-if="columnShown === 'Countries' || window.width > '710'"
          sortable
        ></el-table-column>
        <el-table-column
          label="Subscribers"
          prop="subscribers"
          align="right"
          v-if="columnShown === 'Subscribers' || window.width > '710'"
          :formatter="commaNumTable"
          sortable
        ></el-table-column>
        <el-table-column
          label="Views"
          prop="views"
          align="right"
          v-if="columnShown === 'Views' || window.width > '710'"
          :formatter="commaNumTable"
          sortable
        ></el-table-column>
      </el-table>
      <div class="card-footer">
        <p></p>
      </div>
    </el-card>
  </el-col>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  components: {},

  computed: {
    ...mapState('artistDashboard', [
      'loading_channel',
      'channel',
      'artist_track',
      'artist_label'
    ])
  },

  data() {
    return {
      columnShown: 'Countries',
      columns: [
        {
          name: 'Countries',
          command: 'country'
        },
        {
          name: 'Subscribers',
          command: 'subscribers'
        },
        {
          name: 'Views',
          command: 'views'
        }
      ]
    }
  },

  watch: {
    artist_track: function(valN, valO) {
      if (valN !== null) {
        this.readTopChannel()
      }
    },
    artist_label: function(valN, valO) {
      if (valN !== null) {
        this.readTopChannel()
      }
    }
  },

  methods: {
    ...mapActions('artistDashboard', ['readTopChannel']),

    handleCommand(column) {
      this.columnShown = column.name
      this.readTopChannel(column.command)
    }
  },

  created() {
    this.readTopChannel()
    window.addEventListener('resize', this.windowWidth)
    this.windowWidth()
  },

  destroyed() {
    window.removeEventListener('resize', this.windowWidth)
  }
}
</script>
